import { createSelector } from 'reselect';
import { RootState } from '../index';

// Basic selectors
export const selectCanvasState = (state: RootState) => state.canvas;

// Derived selectors
export const selectScale = createSelector(
  [selectCanvasState],
  (canvasState) => canvasState.scale
);

export const selectPosition = createSelector(
  [selectCanvasState],
  (canvasState) => canvasState.position
); 